module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "docs-container"
  }, [_c('section', [_c('article', [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "275px"
    }
  }, [(_vm.showTask) ? _c('task-item', {
    attrs: {
      "is-selected": _vm.task.isSelected
    },
    on: {
      "task-selected": _vm.onTaskSelected,
      "task-delete": _vm.onTaskDelete
    },
    model: {
      value: (_vm.task.text),
      callback: function($$v) {
        _vm.task.text = $$v
      },
      expression: "task.text"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('article', [_vm._m(1), _vm._v(" "), _c('div', [_c('tasks-list', {
    attrs: {
      "tasks": _vm.tasks
    }
  })], 1)]), _vm._v(" "), _c('article', [_vm._m(2), _vm._v(" "), _c('div', [_c('clock', {
    attrs: {
      "time": _vm.time
    }
  })], 1)]), _vm._v(" "), _c('article', [_c('header', [_c('code', [_c('code', [_vm._v("<gauge v-bind:percent=\"" + _vm._s(_vm.percent) + "\" />")])])]), _vm._v(" "), _c('div', [_c('gauge', {
    attrs: {
      "percent": _vm.percent
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('code', [_vm._v("<task-item v-model=\"'El piso Limpio'\" v-bind:is-selected=\"true\"\n\t\t\t\t\t/>\n\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('code', [_vm._v("<tasks-list v-bind:tasks=\"tasks\" />")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('code', [_vm._v("<clock v-bind:time=\"'00:45'\" />")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-367d58fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Docs.vue
// module id = 1620
// module chunks = 34